import { createSlice } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getBaseTemplates } from './actionCreators';
import { LLMTemplatesState, SLICE_NAME, initialState } from './models';

export const llmTemplatesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBaseTemplates.pending, (state: LLMTemplatesState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBaseTemplates.fulfilled, (state: LLMTemplatesState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.templates = payload;
      })
      .addCase(getBaseTemplates.rejected, (state: LLMTemplatesState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
